const bannerImage = () => {

    function BannerLoad() {
        var BannerImages = document.querySelectorAll("img.banner-img");
        BannerImages.forEach(function (img: HTMLImageElement) {
            if (img.dataset.mobileimage && img.dataset.mobileimage.length != 0) {
                if (document.documentElement.clientWidth < 992) {
                    img.src = img.dataset.mobileimage;
                } else {
                    img.src = img.dataset.image;
                }
            }
        });
    }
    window.addEventListener("resize", BannerLoad);
    window.addEventListener("orientationChange", BannerLoad);

};

export {
    bannerImage
};
